import { render, staticRenderFns } from "./Audios.vue?vue&type=template&id=4651dda9&"
import script from "./Audios.vue?vue&type=script&lang=ts&"
export * from "./Audios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports